import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.css'],
  imports: [CommonModule],
})
export class SkeletonComponent {
  @Input() width = '100%';
  @Input() height = '16px';
  @Input() borderRadius = '4px';
  @Input() count = 1;
  @Input() marginBottom = '8px';

  get items(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
